import React from 'react';
import FeedPostAssetCarousel, { Post } from './FeedPostAssetCarousel';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Grid from 'atoms/Layout/Grid/Grid';

interface FeedPostSliderProps {
  posts: Post[];
}

const FeedPostSlider = ({ posts }: FeedPostSliderProps): JSX.Element => {
  return (
    <Grid totalColumns={1}>
      <Stack
        overflow='visible'
        align='flex-start'
        justify='flex-start'
      >
        <FeedPostAssetCarousel posts={posts} />
      </Stack>
    </Grid>
  );
};

export default FeedPostSlider;
